import Listing from '../components/content';
import Pagination from '../components/pagination';
import Counter from '../components/counter';
import FiltersList from '../components/filtersList';
import __Product from './product.js';

const DOC = document;

export default function (form) {

	const CORE = {

		/**	Objet contenant les principaux éléments de la page
		 * @var {object}
		 */
		nodes: {
			Listing: Listing(),
			Counter: Counter(),
			Pagination: Pagination(),
			FiltersList: FiltersList()
		},

		/**	Objet contenant les données du formulaire
		 * @var {object}
		 */
		data: {},

		filters: {

			/** Objet contenant les filtres actifs et composé comme suit:
			 * [
			 * 	{
			 * 		name: 'xxxx', attr input name
			 * 		title: 'xxxxx', attr input title
			 * 		node: {object} node objet input
			 * 		filter: {object} node objet filter
			 * 	}
			 * ]
			 * @var	{object}
			 */
			filters: [],

			/** Nombre de filtres actifs
			 * @var {int}
			 */
			count: 0,

			removeAll: function () {
				var filters = CORE.filters.filters;
				var i = 0;
				var parent;


				if (!filters.length) {
					return false;
				}

				for (i; i < filters.length; i++) {
					parent = filters[i].filter.parentNode;

					filters[i].node.checked = false;

					parent.parentNode.removeChild(parent);

					CORE.filters.count--;

					CORE.filters.filters.splice(i, 1);
					--i;

				}

				if (CORE.filters.count < 1) {
					$('.top-filter-panel').hide();
				}
				return true;

			},

			remove: function (name) {
				var filters = CORE.filters.filters;
				var i = 0;
				var parent;

				if (!filters.length) {
					return false;
				}

				for (i; i < filters.length; i++) {

					if (filters[i].name == name) {
						parent = filters[i].filter.parentNode;

						parent.parentNode.removeChild(parent);

						CORE.filters.count--;

						CORE.filters.filters.splice(i, 1);

						if (CORE.filters.count < 1) {
							$('.top-filter-panel').hide();

						}
						return true;
					}

				}
				return false;

			},

			onRemove: function (e, el, node) {

				e.preventDefault();

				if (!CORE.filters.remove(node.name)) {
					return;
				}
				node.checked = false;

				CORE.submit.onSubmit(e);

			},

			exists: function (name) {
				var filters = CORE.filters.filters;
				var i = 0;

				if (!filters.length) {
					return false;
				}

				for (i; i < filters.length; i++) {

					if (filters[i].name == name) {
						return true;
					}

				}
				return false;

			},

			addFilter: function (node) {
				var EL;

				if (typeof node !== 'object' || node === null || !node) {
					return false;
				}

				if (CORE.filters.exists(node.name)) {
					return false;
				}

				EL = DOC.createElement('span');
				EL.className = 'selected-item';
				EL.innerHTML = '<a href="#" class="remove"></a><span class="text">' + node.title + '</span>';

				EL.firstChild.addEventListener('click', function (e) {
					CORE.filters.onRemove(e, this, node);
				});

				CORE.nodes.FiltersList.append(EL);

				CORE.filters.count++;

				CORE.filters.filters[CORE.filters.filters.length] = {
					name: node.name,
					title: node.title,
					node: node,
					filter: EL.firstChild
				};

				if (CORE.filters.count === 1) {
					$('.top-filter-panel').css('display', 'flex');

				}

			}

		},

		ajax: {

			success: function (result) {
				var nodes = CORE.nodes;

				nodes.Listing.set(result.prds);
				nodes.Pagination.set(result.pagination);
				nodes.Counter.set(result.total);
				CORE.pagination.construct();

        var product = DOC.getElementsByClassName( 'product-form' );
        var i = 0;

        if (typeof product !== 'object' || product == null || !product.length) {
          return;
        }
        this.product = [];

        for (i; i < product.length; i++) {
          this.product[this.product.length] = product[i];

          // Une classe "__init" est ajouté à l'élement pour éviter de réconstruction les events JS dessus une seconde fois
          // Sans cela, la popup d'ajout au panier s'affichera plusieurs fois si l'on clique sur deux boutons d'ajout au panier dans
          // le listing produit
          if( !$( product[i] ).hasClass('__init') ){
            $( product[i] ).addClass('__init');
            __Product.Product($('body'), product[i]);
          }
        }
			},

			fail: function (message) {
				var nodes = CORE.nodes;

				nodes.Listing.set(message);
				nodes.Pagination.reset();
				nodes.Counter.set('0 articles');

			},

			done: function (response) {
				var self = CORE.ajax;
				response = JSON.parse(response);

				if (typeof response !== 'object' || !('content' in response) || !('success' in response)) {
          $('.rf-ajax-load').hide();
					self.fail('Une erreur est survenue. Veuillez réessayer.');
					return;
				}

				if (response.success != 1 || typeof response.content !== 'object') {

					if (typeof response.content === 'string' && response.content) {
            self.fail(response.content);
            $('.rf-ajax-load').hide();
						return;
          }

          $('.rf-ajax-load').hide();
					self.fail('Une erreur est survenue. Veuillez réessayer.');
					return;
        }

        self.success(response.content);
        $('.rf-ajax-load').hide();
			}

		},

		orderby: {

			className: 'category-orderby--change',

			element: null,

			onChange: function (e) {
				CORE.submit.onSubmit(e);

			},

			construct: function () {
				var elements = form.getElementsByClassName(this.className);
				var i = 0;
				var element;

				if (typeof elements !== 'object' || elements == null || !elements.length) {
					return;
				}
				this.elements = [];

				for (i; i < elements.length; i++) {
					element = elements[i];
					this.elements[this.elements.length] = element;
					element.addEventListener('change', this.onChange);
				}

			}

		},

		getFormData: function (action, reset) {
			var fields = form.elements;
			var i = 0;
			var regex = /\[([0-9]+)\]/i;
			var field, fld, r;

			reset = typeof reset === 'boolean' ? reset : false;

			CORE.data = {};

			if (typeof action === 'string') {
				CORE.data.action = action;
			}

			if (typeof fields !== 'object' || fields == null || !('length' in fields) || !fields.length) {
				return CORE.data;
			}

			for (i; i < fields.length; i++) {
				field = fields[i];

				if (typeof field.name !== 'string' || !field.name.length) {
					continue;
				}

				if ('type' in field && (field.type == 'checkbox' || field.type == 'CHECKBOX')) {
					if (field.checked !== true) {
						CORE.filters.remove(field.name);
						continue;
					}
				}

        		var filter_name = field.name;

				if (field.name.search(regex) >= 0) {
        			CORE.filters.addFilter(field);

          			if( field.name.match(/(fld\[])/i) !== null ){
            			r = field.name.match(regex);

						if (!r || r == null || r.length < 2) {
						continue;
						}

            			fld = r[1];

						if (typeof CORE.data.fld !== 'object') {
							CORE.data.fld = {};
						}

						if (typeof CORE.data.fld[fld] !== 'object') {
							CORE.data.fld[fld] = [];
						}
            		
						CORE.data.fld[fld][CORE.data.fld[fld].length] = field.value;
            			continue;
					} else if( field.name.match(/(brand)/i) !== null ){
            			filter_name = 'brand[' + i + ']';
          			}
				}

       			CORE.data[ filter_name ] = field.value;
			}

			if (reset) {
				CORE.data = {};

				if (typeof action === 'string') {
					CORE.data.action = action;
				}
				return CORE.data;
			}

			if ('prcmin' in CORE.data && 'prcmax' in CORE.data) {
				CORE.data['value-range'] = CORE.data.prcmin + '/' + CORE.data.prcmax;
			}
			return CORE.data;

		},

		getParameterByName: function (name, url) {
			name = name.replace(/[\[\]]/g, '\\$&');
			var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
				results = regex.exec(url);
			if (!results) return null;
			if (!results[2]) return '';
			return decodeURIComponent(results[2].replace(/\+/g, ' '));
		},

		pagination: {

			className: 'content-pagination__item__link',

			elements: null,

			page: 1,

			loadPage: function (node) {
				var page = 1;

				if (typeof node !== 'object' || node === null || !('href' in node) || node.nodeName != 'A') {
					CORE.pagination.page = page;
					return CORE.pagination.page;
				}
				page = CORE.getParameterByName('page', node.href);
				page = parseInt(page);
				page = page > 0 ? page : 1;

				CORE.pagination.page = page;

				return CORE.pagination.page;

			},

			onSubmit: function (e) {
        $('.rf-ajax-load').show();

				var formData;

				e.preventDefault();

				CORE.pagination.loadPage(this);
				formData = CORE.getFormData('change-page');
				formData.page = CORE.pagination.page;

				$.ajax({
					method: 'GET',
					url: '/ajax/catalog.php',
					data: formData
				}).done(CORE.ajax.done);

        return false;
			},

			construct: function () {
				var elements = document.getElementsByClassName(this.className);
				var i = 0;
        var element;

				if (typeof elements !== 'object' || elements == null || !elements.length) {
					return;
				}
				this.elements = [];

				for (i; i < elements.length; i++) {
					element = elements[i];
					this.elements[this.elements.length] = element;
					element.addEventListener('click', this.onSubmit);
				}

			}

		},

		submit: {

			className: 'category-filter--submit',

			elements: null,

			onSubmit: function (e, reset) {
        $('.rf-ajax-load').show();

				var formData;

				e.preventDefault();

				formData = CORE.getFormData('apply-filters', reset);
				formData.page = CORE.pagination.page;

				$.ajax({
					method: 'GET',
					url: '/ajax/catalog.php',
					data: formData
				}).done(CORE.ajax.done);
        return false;
			},

			construct: function () {
				var elements = form.getElementsByClassName(this.className);
				var i = 0;
				var element;

				if (typeof elements !== 'object' || elements == null || !elements.length) {
					return;
				}
				this.elements = [];

				for (i; i < elements.length; i++) {
					element = elements[i];
					this.elements[this.elements.length] = element;
					element.addEventListener('click', this.onSubmit);
				}

			}
		},

		reset: {

			className: 'selected-filters__del',

			elements: null,

			onReset: function (e) {

				e.preventDefault();

				window.location.reload();

			},

			construct: function () {
				var elements = form.getElementsByClassName(this.className);
				var i = 0;
				var element;

				if (typeof elements !== 'object' || elements == null || !elements.length) {
					return;
				}
				this.elements = [];

				for (i; i < elements.length; i++) {
					element = elements[i];
					this.elements[this.elements.length] = element;
					element.addEventListener('click', this.onReset);
				}

			}
		},

		construct: function () {
			CORE.reset.construct();
			CORE.orderby.construct();
			CORE.submit.construct();
			CORE.pagination.construct();
		}
	};

	CORE.construct();
};
